import { SVG } from '../SVG'

const CalendarIcon = ({ inactive = false, style = {}, ...props }) => {
  return (
    <SVG width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg' style={{ ...style }} {...props}>
      <path
        d='M26 5H6C5.44772 5 5 5.44772 5 6V26C5 26.5523 5.44772 27 6 27H26C26.5523 27 27 26.5523 27 26V6C27 5.44772 26.5523 5 26 5Z'
        fill='none'
        stroke={inactive ? 'var(--primary-color)' : 'var(--svg-darker-fill)'}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M22 3V7'
        stroke={inactive ? 'var(--primary-color)' : 'var(--svg-darker-fill)'}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10 3V7'
        stroke={inactive ? 'var(--primary-color)' : 'var(--svg-darker-fill)'}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5 11H27'
        stroke={inactive ? 'var(--primary-color)' : 'var(--svg-darker-fill)'}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M20 15L24 15' stroke={inactive ? 'var(--primary-color)' : 'var(--svg-darker-fill)'} strokeWidth='2' />
      <path d='M14 15L18 15' stroke={inactive ? 'var(--primary-color)' : 'var(--svg-darker-fill)'} strokeWidth='2' />
      <path d='M8 15L12 15' stroke={inactive ? 'var(--primary-color)' : 'var(--svg-darker-fill)'} strokeWidth='2' />
      <path d='M20 19H24' stroke={inactive ? 'var(--primary-color)' : 'var(--svg-darker-fill)'} strokeWidth='2' />
      <path d='M14 19H18' stroke={inactive ? 'var(--primary-color)' : 'var(--svg-darker-fill)'} strokeWidth='2' />
      <path d='M8 19H12' stroke={inactive ? 'var(--primary-color)' : 'var(--svg-darker-fill)'} strokeWidth='2' />
      <path d='M20 23H24' stroke={inactive ? 'var(--primary-color)' : 'var(--svg-darker-fill)'} strokeWidth='2' />
      <path d='M14 23H18' stroke={inactive ? 'var(--primary-color)' : 'var(--svg-darker-fill)'} strokeWidth='2' />
      <path d='M8 23H12' stroke={inactive ? 'var(--primary-color)' : 'var(--svg-darker-fill)'} strokeWidth='2' />
    </SVG>
  )
}

export default CalendarIcon
